// The wind direction reading is an unsigned 12-bit ADC value. This value is first converted to volts and then to degrees (0 = North, 90 = East, 180 = South, 270 = West). The ConversionFormulaOffset parameter is used to add an offset value to the North alignment of the sensor. Convert the 12-bit ADC value ($rdg in code below) to degrees ($deg in code below) using the following algorithm:
// $deg = 0.0;

/*
if ( $rdg == 0xFFF ) {
  $deg = null; // display reading as “invalid”
} else {
  $volt = ((float)$rdg)/327.6;
  $deg = ($volt * 360.0) / 5.0;

  if ($deg >= 360.0) {
    $deg = 0.0;
  }

  $offset = (float)$ConversionFormulaOffset;

  if ( ($offset > 0.0) && ($offset < 360.0) ) {
    $deg = $deg - $offset;
    if ($deg < 0) {
      $deg += 360.0;
    }
  }
}
*/

// To calibrate the sensor, align the wind direction sensor to North, read the ADC value and use the code above, using an offset value of 0.0, to calculate the degree. The calculated degree is the new offset value. Store the new offset value in the ConversionFormulaOffset parameter.

export function windDirection(
  reading: number,
  scale: number,
  offset: number,
  frequency: number
): number {
  const voltage = reading / 327.6
  var degrees = (voltage * 360.0) / 5.0

  if (degrees >= 360.0) {
    degrees = 0.0
  }

  if (offset > 0.0 && offset < 360.0) {
    degrees = degrees - offset
    if (degrees < 0) {
      degrees += 360.0
    }
  }

  return degrees
}
